<div *ngIf="port" class="modal-backdrop" (click)="onBackdropClick($event)">
  <div class="modal-container">
    <div class="modal-header">
      <div>
        <h2 class="modal-title">{{port.name}}, {{port.country}}</h2>
        <p class="modal-subtitle">
          {{portDisruptions.length}} active issue{{portDisruptions.length !== 1 ? 's' : ''}}
        </p>
      </div>
      <button class="close-button" (click)="onClose()">
        ✕
      </button>
    </div>

    <div class="modal-content">
      <div *ngIf="portDisruptions.length > 0; else noDisruptions" class="disruptions-list">
        <div *ngFor="let disruption of portDisruptions" class="disruption-item">
          <div class="disruption-content">
            <div class="disruption-icon">
              <lucide-icon [name]="getWeatherIcon(disruption.category)"></lucide-icon>
            </div>
            <div class="disruption-details">
              <h3 class="disruption-title">{{disruption.title}}</h3>
              <p class="disruption-summary">{{disruption.summary}}</p>
              
              <div *ngIf="disruption.delay_info?.has_delay" class="delay-info">
                <div class="delay-header">
                  <lucide-icon name="clock"></lucide-icon>
                  <span class="delay-text">
                    Estimated delay: {{disruption.delay_info.duration}} {{disruption.delay_info.unit}}(s)
                  </span>
                </div>
                <p *ngIf="disruption.delay_info.reason" class="delay-reason">
                  {{disruption.delay_info.reason}}
                </p>
              </div>
              
              <a *ngIf="disruption.source_link" 
                 [href]="disruption.source_link" 
                 target="_blank" 
                 rel="noopener noreferrer"
                 class="source-link">
                Read more details →
              </a>
            </div>
          </div>
        </div>
      </div>

      <ng-template #noDisruptions>
        <p class="no-disruptions">No current issues reported at this port.</p>
      </ng-template>
    </div>
  </div>
</div>